export default __webpack_public_path__ + "static/media/folder-large-green-3x.80e8c6c6.png";